import React from 'react';
import { Tag } from 'sonata-react-components';
import { DeviceCarrier, DeviceCarrierApiResponse } from 'sonata-static-storage/lib/common/common.types';
import { worldCountries } from 'sonata-static-storage/lib/samples/worldCountries.samples';

import { CarriersListStyled } from './CarriersList.styled';

type Props = {
  availableCarriers: Record<string, DeviceCarrierApiResponse>;
  carriers: DeviceCarrier[];
  onRemoveCarrier: (carrierId: string) => void;
};

export const CarriersList: React.FC<Props> = ({ availableCarriers, carriers, onRemoveCarrier }) => {
  const carriersToBeRendered = carriers.reduce((acc: { country: string; id: string; label: string }[], carrier) => {
    const carriersToBeAdded = Object.keys(carrier).map(carrierKey => {
      const { brand, countryCode } = availableCarriers[carrierKey];
      return {
        country:
          worldCountries.find(({ cca3 }) => cca3.toLowerCase() === countryCode.toLowerCase())?.name.common || 'N/A',
        id: carrierKey,
        label: brand
      };
    });
    return acc.concat(carriersToBeAdded);
  }, []);

  return (
    <CarriersListStyled className="carriersListContainer">
      {carriersToBeRendered.map(({ country, id, label }) => (
        <Tag
          className="carriersListContainer__tag"
          icon={{
            color: 'var(--color-status-enabled-600)',
            position: 'right',
            webFont: 'fas fa-times'
          }}
          id={`${id}_carrierTag`}
          key={`${id}_carrierTag`}
          onClick={() => onRemoveCarrier(id)}
          status="enabled"
        >
          {`${label} (${country})`}
        </Tag>
      ))}
    </CarriersListStyled>
  );
};
